class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }

    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.closeNewsletter();
      }
    });

    // Fixed button to reopen popup
    this.fixedButton = document.getElementById(`NewsletterFixedButton-${this.id.replace('NewsletterModal-', '')}`);
    if (this.fixedButton) {
      this.fixedButton.addEventListener("click", this.openFromFixedButton.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
    this.hasScrolledEnough = false;
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
    this.updateFixedButtonVisibility();
  }

  openFromFixedButton() {
    this.show();
    this.updateFixedButtonVisibility();
  }

  updateFixedButtonVisibility() {
    if (!this.fixedButton) return;

    const isPopupOpen = this.hasAttribute("open");
    const isSubscribed = getCookie("newsletter-subscribed") === "true";

    // Show button only when:
    // 1. User has scrolled more than 100vh
    // 2. Popup is closed
    // 3. User hasn't subscribed
    if (this.hasScrolledEnough && !isPopupOpen && !isSubscribed) {
      this.fixedButton.classList.add("is-visible");
    } else {
      this.fixedButton.classList.remove("is-visible");
    }
  }

  handleScroll() {
    const scrollPosition = window.scrollY;
    const viewportHeight = window.innerHeight;

    this.hasScrolledEnough = scrollPosition > viewportHeight;
    this.updateFixedButtonVisibility();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      this.updateFixedButtonVisibility();
      return;
    }

    this.handlePopupVisibility();
    // Set initial button visibility
    setTimeout(() => this.updateFixedButtonVisibility(), 100);

    // Watch for popup state changes to update button visibility
    this.setupFixedButtonObserver();

    // Attach scroll listener for fixed button visibility
    if (this.fixedButton) {
      this.scrollHandler = this.handleScroll.bind(this);
      window.addEventListener("scroll", this.scrollHandler, { passive: true });
      // Check initial scroll position
      this.handleScroll();
    }
  }

  disconnectedCallback() {
    // Clean up scroll listener
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  }

  setupFixedButtonObserver() {
    if (!this.fixedButton) return;

    const observer = new MutationObserver(() => {
      this.updateFixedButtonVisibility();
    });

    observer.observe(this, { attributes: true, attributeFilter: ['open'] });
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
    this.updateFixedButtonVisibility();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
